import firebase from 'firebase';

var config = {
    apiKey: "AIzaSyAJnofaINEq6DzQswxgr_76Jpi4ruaq4wE",
    authDomain: "racoon-food.firebaseapp.com",
    databaseURL: "https://racoon-food.firebaseio.com",
    projectId: "racoon-food",
    storageBucket: "racoon-food.appspot.com",
    messagingSenderId: "812843642049"
    };
    if (!firebase.apps.length) {
        firebase.initializeApp(config);
    }
export const auth = firebase.auth()
export const db = firebase.firestore();
db.settings({
    timestampsInSnapshots: true
});
export const uiConfig = {
    callbacks: {
        signInSuccessWithAuthResult: (result, redirectUrl) => {
            handleAuth(result.user);
            return false;
        },
        signInFailure: (error) => {
            // Handle Errors here.
            var errorCode = error.code;
            var errorMessage = error.message;
            console.log("Error ", errorCode, errorMessage);
        }
    },
    // Popup signin flow rather than redirect flow.
    signInFlow: 'popup',
    // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
    signInSuccessUrl: '/',
    // We will display Google and Facebook as auth providers.
    signInOptions: [
    firebase.auth.FacebookAuthProvider.PROVIDER_ID,
    firebase.auth.TwitterAuthProvider.PROVIDER_ID
    ]
  };

function handleAuth(user){
    let query = null;
    db.collection("users").where('uid', '==', user.uid).get()
    .then((querySnapshot => {
        querySnapshot.forEach(user => {
            query = user;
        })
    }))
    .then(() => {if(!query) createUser(user)})
}

function createUser(user){
    const userRef = db.collection("users").add({
        uid : user.uid,
        name : user.displayName,
        email : user.email,
        photo : user.photoURL,
        posts : [],
    }); 
    // save user's info to user table
    return;
}